import { GenerateQueriesArgs, generateQueries } from 'src/queries/queryGenerator'
import { Currency } from 'src/types'
import { displayCurrencyUnit } from 'src/utils'

export const CURRENCIES_ENDPOINT = 'currencies'
export const CURRENCIES_QUERY_KEY = 'currencies'

export interface CurrencyQueryParams {
  id?: Id[]
}

const generateQueriesConfig: GenerateQueriesArgs<Currency, CurrencyQueryParams> = {
  endpoint: CURRENCIES_ENDPOINT,
  queryKey: CURRENCIES_QUERY_KEY,
  useAllEntitiesQueryArgs: {
    queryOptions: {
      cacheTime: 1000 * 60 * 120,
      staleTime: 1000 * 60 * 60,
    },
  },
}

export const { useAllEntitiesQuery: useCurrenciesQuery } = generateQueries(generateQueriesConfig)

export const useDisplayedCurrencyByIdQuery = (currencyId?: Id) =>
  useCurrenciesQuery({
    queryOptions: {
      select: currencies => displayCurrencyUnit(currencies?.find(({ id }) => id === currencyId)),
    },
  })
